module.exports = __webpack_public_path__ + "img/product2.653ca8be.png";